import * as types from '../actionTypes/CreateAccountActionTypes';

function CreateAccountReducer(state = {}, action = {}) {
    switch (action.type) {
        case types.CREATE_ACCOUNT:
            return {};

        case types.CREATE_ACCOUNT_SUCCESS: {
            const createAccount = action.payload;
            return createAccount;
        }
        case types.CREATE_ACCOUNT_ERROR: {
            return { ...state, ...action.payload };
        }

        default:
            return state;
    }
}
CreateAccountReducer.reducerName = 'CreateAccount';
export default CreateAccountReducer;
